import React from "react";
import { clsx } from "clsx";
import { Placeholder } from "@bloomberg/media-ui-article";
import typographyStyles from "@bloomberg/media-ui-tokens/css/typography.module.css";

import {
    LiveBlogPost,
    PostPlaceholder,
} from "~components/shared/liveblog/index";
import { TranslatedMessage } from "~i18n/translate";
import type { LiveBlog } from "~types/types";

import styles from "./liveblog.module.css";

export interface LiveBlogPostsProps {
    liveBlog?: LiveBlog | null;
    loaded?: boolean;
    failed?: boolean;
    url: string;
    className?: string;
    keypointsToggle?: boolean;
    storyIndex?: number;
}

export function LiveBlogPosts({
    liveBlog,
    className,
    url,
    loaded,
    failed,
    keypointsToggle = false,
    storyIndex = 0,
}: LiveBlogPostsProps) {
    const isClosed = liveBlog?.state === "closed";
    const useKeypoints = isClosed || keypointsToggle;
    const postsToUse =
        (useKeypoints ? liveBlog?.keypoints : liveBlog?.posts) || [];

    return (
        <div
            className={clsx(styles.posts, className)}
            data-component="liveblog-posts"
        >
            <div className={clsx(styles.label, typographyStyles.articleLabel)}>
                {useKeypoints ? (
                    <TranslatedMessage
                        id="keyUpdates"
                        defaultMessage="Key Updates"
                    />
                ) : (
                    <TranslatedMessage
                        id="latestUpdates"
                        defaultMessage="Latest Updates"
                    />
                )}
            </div>
            {loaded &&
                postsToUse.map((post, index) => (
                    <LiveBlogPost
                        storyIndex={storyIndex}
                        relatedIndex={index + 1}
                        post={post}
                        url={url}
                        key={post.id}
                    />
                ))}

            {!loaded && !failed && (
                <Placeholder>
                    <PostPlaceholder />
                    <PostPlaceholder />
                </Placeholder>
            )}

            {failed && (
                <div
                    className={clsx(
                        styles.fetchError,
                        typographyStyles.coreShortTextSm
                    )}
                >
                    <TranslatedMessage
                        id="noPostsFound"
                        defaultMessage="No posts found, please try again later."
                    />
                </div>
            )}
        </div>
    );
}
